import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { openExternalLink } from "@/components/Membership/openExternalLink";
import { EducationVideoId, getEducationVideos, youTubeWatchUrl } from "./educationVideos";

/**
 * Opens an education video: in the app's player, or on YouTube on iOS. The iOS web view runs
 * from capacitor://, which sends YouTube's embed no referrer, and the embed refuses to play.
 */
export function useOpenEducationVideo() {
  const navigate = useNavigate();

  return useCallback(
    (id: EducationVideoId) => {
      if (Capacitor.getPlatform() === "ios") {
        openExternalLink(youTubeWatchUrl(getEducationVideos()[id].youtubeId));
        return;
      }
      navigate(`/education-video/${id}`);
    },
    [navigate]
  );
}
